import React, { Component } from 'react';
import Tooltip from 'rc-tooltip';
import Slider from 'rc-slider';

import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';

const Handle = Slider.Handle;


class PercentSlider extends Component {

	handle = (props) => {
		const { value, dragging, index, ...restProps } = props;

		return (
			<Tooltip overlay={`${value}${this.props.suffix || ''}`} visible={dragging} placement="top" key={index}>
				<Handle value={value} {...restProps} />
			</Tooltip>
		);
	}

	render() {
		const { min, max, suffix } = this.props;

		let marks = {};
		marks[min] = `${min}${suffix || ''}`;
		marks[max] = `${max}${suffix || ''}`;

		return <Slider {...this.props} marks={marks} handle={this.handle} />
	}
}

export default PercentSlider;